<template>
  <div id="layer-invoice-publish">
    <win-layer-pop class="layer-sub-invoice-publish">
      <component
        v-if="custCompInvoice"
        :is="custCompInvoice"
        :is-show-pop="isInvoiceShowPop"
        :parent-info="invoiceParam"
        @close="closeInvoce"
      />
    </win-layer-pop>
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import calcIssueApi from '@/api/rest/settle/calcIssue'
import BlInvoiceFreightPop from '@/pages/pdf/popup/BlInvoiceFreightPop'
import BlProformaInvoiceIdPop from '@/pages/pdf/popup/BlProformaInvoiceIdPop'
import WinLayerPop from '@/pages/trans/popup/WinLayerPop'

export default {
  name: 'InvoicePublishPop',
  components: {
    WinLayerPop,
    BlInvoiceFreightPop,
    BlProformaInvoiceIdPop,
    ProformaFreightPop: () => import('@/pages/pdf/popup/ProformaFreightPop')
  },
  props: {
    invoiceData: {
      type: Array,
      default: function () {
        return []
      }
    },
    asEiCatCd: {
      type: String,
      default: 'O'
    }
  },
  data () {
    return {
      custCompInvoice: '',
      isInvoiceShowPop: {},
      invoiceParam: {},
      ProformaFreightParam: {},
      invoiceDataList: [],
      arrayBlNo: [],
      eiCatCd: '',

      isCalcRate: ''
    }
  },
  computed: {
    ...rootComputed
  },
  watch: {
    // invoiceData () {
    //   this.init()
    //   this.setInvoiceData()
    // },
    // asEiCatCd () {
    //   this.init()
    // }
  },
  created () {},
  mounted () {},
  methods: {
    // init () {
    //   this.invoiceDataList = this.invoiceData
    //   this.eiCatCd = this.asEiCatCd
    // },
    async setInvoiceData () {
      if (this.invoiceDataList.length === 0) {
        this.openAlert('Invoice를 출력할 B/L이 없습니다.')
        return
      }

      this.invoiceParam = {
        testCtrCd: '',
        testAgtCd: '',
        testBkgPlcCd: '',
        items: []
      }

      let blInvoiceParam = {
        asLangCd: this.auth.serviceLang,
        inBound: this.eiCatCd,
        blList: []
      }
      this.ProformaFreightParam = {
        testCtrCd: '',
        testUsrNo: '',
        testBkgPlcCd: '',
        testAgtCd: '',
        items: []
      }

      this.arrayBlNo = []

      const ctrCd = this.memberDetail.userCtrCd
      if (ctrCd === 'ID' || ctrCd === 'VN' || ctrCd === 'MY' || ctrCd === 'CN') {
        //ID
        //VN
        //MY
        //CN(SHASHA,TAOTAO,HKCSZP,XGGXGG)
        let blData = {
          asArrBlNo: [],
          asCtrCd: this.memberDetail.userCtrCd,
          asCstNo: this.memberDetail.cstCd
        }
        this.invoiceDataList.forEach(vo => {
          blData.asArrBlNo.push(vo.blNo)
        })

        let resultBl = []
        await calcIssueApi.findBlProformaFreightInvoice(blData)
          .then(async response => {
            console.log('findBlProformaFreightInvoice 결과 >>', response)
            if (response.data) {
              resultBl = response.data
            }
          })
        if (resultBl.length === 0) {
          this.alertType('B/L의 운임 정보를 찾을 수 없습니다.')
          return
        }

        resultBl.forEach(vo => {
          if (ctrCd === 'CN') {
            if (vo.payAgtOrgNo === 'SHASHA' || vo.payAgtOrgNo === 'TAOTAO' || vo.payAgtOrgNo === 'HKCSZP' || vo.payAgtOrgNo === 'XGGXGG') {
              const blObj = {
                portCd: this.eiCatCd === 'O' ? vo.podPortCd : vo.polPortCd,
                payAgtorgNo: vo.payAgtOrgNo,
                blNo: vo.blNo,
                cstNo: this.memberDetail.cstCd,
                to: this.memberDetail.cstCd,
                remark: ''
              }
              this.arrayBlNo.push(blObj)
            }
          } else {
            const blObj = {
              portCd: this.eiCatCd === 'O' ? vo.podPortCd : vo.polPortCd,
              payAgtorgNo: vo.payAgtOrgNo,
              blNo: vo.blNo,
              cstNo: this.memberDetail.cstCd,
              to: this.memberDetail.cstCd,
              remark: ''
            }
            this.arrayBlNo.push(blObj)
          }
        })
      } else {
        let tmpData = []
        let issBlData = []
        this.invoiceDataList.forEach(v => {
          if (this.$_.trim(v.invIssNo) !== '') {
            const invoceInfo = {
              invIssNo: v.invIssNo,
              to: '',
              remark: '',
              filter: 'BL',
              blNo: v.blNo,
              esign: ''
            }
            tmpData.push(invoceInfo)
            this.arrayBlNo.push(invoceInfo)
          }
          if (this.$_.trim(v.invIssNo) === '' && this.$_.trim(v.invRno) !== '') {
            const blInfo = {
              blNo: v.blNo,
              invRno: v.invRno,
              index: v.reqCnt,
              mainYn: 'N'
            }
            issBlData.push(blInfo)
          }
        })
        if (issBlData.length > 0) {
          blInvoiceParam.blList = issBlData
          console.log('Invoce 번호생성 >>', blInvoiceParam)
          if (blInvoiceParam.blList.length > 0) {
            console.log(JSON.stringify(blInvoiceParam))
            const invoiceList = await this.invoicePublish(blInvoiceParam)
            console.log('invoiceList >', invoiceList)
            if (invoiceList.length > 0) {
              invoiceList.forEach(v => {
                const invoceInfo = {
                  invIssNo: v.invIssNo,
                  to: '',
                  remark: '',
                  filter: 'BL',
                  blNo: v.blNo,
                  esign: ''
                }
                tmpData.push(invoceInfo)
                this.arrayBlNo.push(invoceInfo)
              })
            }
          }
        }
      }
      if (this.arrayBlNo.length === 0) {
        this.openAlert('Invoice를 출력할 B/L이 없습니다.')
        return
      }
      this.openInvoice()
    },
    openInvoice () {
      const ctrCd = this.memberDetail.userCtrCd

      let componentName
      if (ctrCd === 'ID' || ctrCd === 'VN' || ctrCd === 'MY' || ctrCd === 'CN') {
        // MY
        this.invoiceParam = {
          testCtrCd: '',
          testUsrNo: '',
          testBkgPlcCd: '',
          testAgtCd: '',
          items: this.arrayBlNo
        }
        componentName = 'ProformaFreightPop'
        console.log('PDF >>', this.invoiceParam)
      } else {
        // 일반
        this.invoiceParam = {
          testCtrCd: '',
          testAgtCd: '',
          testBkgPlcCd: '',
          items: this.arrayBlNo
        }
        componentName = 'BlInvoiceFreightPop'
        console.log('PDF >>', this.invoiceParam)
      }

      if (this.isCalcRate === 'popCalcRate') {
        this.isInvoiceShowPop = false

        this.$emit('childs-event', componentName, this.invoiceParam)
        this.isCalcRate = ''
      } else {
        this.custCompInvoice = componentName
        this.isInvoiceShowPop = true
        $('#layer-invoice-publish > .popup_dim').fadeIn()
        $('body, html').css('overflow', 'hidden')
      }
    },
    closeInvoce () {
      this.$store.commit('settle/updateIsInvoicePublishPop', true)
      this.invoiceParam = {}
      this.isInvoiceShowPop = false
      this.custCompInvoice = null
      $('#layer-invoice-publish > .popup_dim').fadeOut()
      $('body, html').removeAttr('style')
    },
    openAlert (msg) {
      let obj = {
        alertType: 'simple',
        onClose: this.closeFun,
        customCloseBtnClass: 'button blue lg simplert-test1',
        customCloseBtnText: this.$t('msg.CSBK100.137'),
        useIcon: false,
        customClass: 'simple_alert',
        message: msg,
        type: 'info'
      }
      this.$ekmtcCommon.alert(obj)
    },
    async invoicePublish (data) {
      let rtn = []
      try {
        await calcIssueApi.invoicePublish(data)
          .then(async response => {
            console.log('Invoice 번호 생성 결과 >>')
            console.log(response)
            if (response.data) {
              rtn = response.data
            }
          })
      } catch (e) {
        console.log(e)
      } finally {
        console.log('!종료')
      }
      return rtn
    },
    openInvoicePop (invoiceData, asEiCatCd, data) {
      this.isCalcRate = data
      this.invoiceDataList = invoiceData
      this.eiCatCd = asEiCatCd
      this.setInvoiceData()
    }
  }
}
</script>
